import { ProductPricingContextDefaultValue, ProductPricingContextShape } from './productPricing/ProductPricingContext'
import { AppState } from './state/AppState'
import { BuilderMode } from './useBuilderMode'
import {
  getDefaultAppState,
  getDefaultClipspecAppState,
  getDefaultWholesalerAppState,
} from './state/getDefaultAppState'

interface BuilderConfig {
  pricingContext: ProductPricingContextShape
  clearListRequested: boolean
  showPackQuantityInCustomise: boolean
  lockToElectricianUserType: boolean
  proSeriesEnabled: boolean
  addingRoomsEnabled: boolean
  canPersistUserData: boolean
  defaultAppState: AppState
}

/**
 * Gets behaviour configuration of the builder, based on current mode.
 * @param builderMode
 * @param defaultPricing
 */
export function getBuilderModeConfiguration(
  builderMode: BuilderMode,
  defaultPricing: ProductPricingContextShape,
): BuilderConfig {
  if (builderMode.name === 'wholesaler') {
    const { wholesalerContext } = builderMode
    return {
      pricingContext: {
        priceMap: wholesalerContext.priceMap,
        isFetching: wholesalerContext.isFetchingPricing,
        requestPricing: wholesalerContext.fetchWholesalerPrice,
        priceTypeLabel: {
          label: 'Wholesale',
          longLabel: wholesalerContext.priceIncludesGst ? 'Price Inc. GST' : 'Price Ex. GST',
        },
        getPackQuantity: (itemNo: string) => wholesalerContext.packQuantityMap[itemNo] ?? null,
        isEnabled: true,
      },
      clearListRequested: false,
      showPackQuantityInCustomise: false,
      defaultAppState: getDefaultWholesalerAppState(wholesalerContext.entryPoint),
      lockToElectricianUserType: true,
      proSeriesEnabled: true,
      addingRoomsEnabled: true,
      canPersistUserData: false,
    }
  }

  if (builderMode.name === 'clipspec') {
    return {
      pricingContext: ProductPricingContextDefaultValue,
      clearListRequested: builderMode.clipspecContext.clearListRequested,
      showPackQuantityInCustomise: true,
      defaultAppState: getDefaultClipspecAppState(),
      lockToElectricianUserType: true,
      proSeriesEnabled: false,
      addingRoomsEnabled: false,
      canPersistUserData: true,
    }
  }

  return {
    defaultAppState: getDefaultAppState(),
    clearListRequested: false,
    showPackQuantityInCustomise: true,
    pricingContext: defaultPricing,
    lockToElectricianUserType: false,
    proSeriesEnabled: true,
    addingRoomsEnabled: true,
    canPersistUserData: true,
  }
}